import { useState, useEffect } from "react";

export default function WhatsAppButton() {
  const [showPopup, setShowPopup] = useState(false);
  const [dismissed, setDismissed] = useState(false);

  const whatsappMessage = encodeURIComponent(
    "Hi Sea Pearl Universal, I'd like to book a cleaning service | مرحباً، أود حجز خدمة تنظيف"
  );
  const whatsappLink = `https://api.whatsapp.com/send?phone=96879964466&text=${whatsappMessage}`;

  useEffect(() => {
    const timer = setTimeout(() => {
      if (!dismissed) setShowPopup(true);
    }, 5000);
    return () => clearTimeout(timer);
  }, [dismissed]);

  const handleDismiss = () => {
    setShowPopup(false);
    setDismissed(true);
  };

  return (
    <>
      {/* Popup */}
      {showPopup && (
        <div className="fixed bottom-24 right-6 z-50 w-80 bg-white rounded-2xl shadow-2xl overflow-hidden animate-fade-in-up">
          {/* Header */}
          <div className="bg-[#25D366] px-4 py-3 flex items-center justify-between">
            <div className="flex items-center gap-2">
              <div className="w-9 h-9 bg-white/20 rounded-full flex items-center justify-center">
                <i className="ri-whatsapp-line text-white text-xl"></i>
              </div>
              <div>
                <p className="text-white font-semibold text-sm leading-tight">Sea Pearl Universal</p>
                <p className="text-white/80 text-xs">Typically replies instantly</p>
              </div>
            </div>
            <button
              onClick={handleDismiss}
              className="text-white/80 hover:text-white transition-colors cursor-pointer"
              aria-label="Close popup"
            >
              <i className="ri-close-line text-xl"></i>
            </button>
          </div>

          {/* Chat bubble */}
          <div className="bg-[#ECE5DD] px-4 py-4">
            <div className="bg-white rounded-xl rounded-tl-none px-4 py-3 shadow-sm max-w-[90%]">
              <p className="text-[#4D4D4D] text-sm leading-relaxed">
                👋 Hello! Ready to book a <strong>professional cleaning service</strong> in Muscat?
              </p>
              <p className="text-[#4D4D4D] text-sm leading-relaxed mt-1 text-right" dir="rtl">
                مرحباً! هل أنت مستعد لحجز خدمة تنظيف احترافية؟
              </p>
              <p className="text-[#25D366] text-xs mt-2 font-medium">✅ Same-day booking available!</p>
              <p className="text-xs text-gray-400 mt-1 text-right">just now</p>
            </div>
          </div>

          {/* CTA */}
          <div className="bg-white px-4 py-3">
            <a
              href={whatsappLink}
              target="_blank"
              rel="noopener noreferrer"
              onClick={handleDismiss}
              className="flex items-center justify-center gap-2 w-full bg-[#25D366] hover:bg-[#1ebe5d] text-white font-semibold text-sm py-2.5 rounded-xl transition-colors cursor-pointer whitespace-nowrap"
            >
              <i className="ri-whatsapp-line text-lg"></i>
              Start Chat &nbsp;|&nbsp; ابدأ المحادثة
            </a>
            <button
              onClick={handleDismiss}
              className="w-full text-center text-xs text-gray-400 hover:text-gray-600 mt-2 cursor-pointer transition-colors"
            >
              No thanks / لا شكراً
            </button>
          </div>
        </div>
      )}

      {/* Floating WhatsApp Button */}
      <div className="fixed bottom-6 right-6 z-50">
        {/* Pulsing rings */}
        <span className="absolute inset-0 rounded-full bg-[#25D366] opacity-60 animate-ping"></span>
        <span
          className="absolute inset-0 rounded-full bg-[#25D366] opacity-30"
          style={{ animation: "ping 1.8s cubic-bezier(0,0,0.2,1) infinite 0.4s" }}
        ></span>
        <a
          href={whatsappLink}
          target="_blank"
          rel="noopener noreferrer"
          className="relative w-14 h-14 bg-[#25D366] rounded-full flex items-center justify-center shadow-xl hover:scale-110 transition-transform cursor-pointer"
          aria-label="Contact us on WhatsApp"
          onClick={() => setShowPopup(false)}
        >
          <i className="ri-whatsapp-line text-white text-3xl"></i>
        </a>
      </div>
    </>
  );
}
